import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class UtilIntegrationService {

  constructor(private http: HttpClient, private utilOBj: UtilService) { }

  sendEmail(reqestPreQual) {
    return this.utilOBj.post(environment.backend_base_url + "integrationservice/sendMAMail", reqestPreQual);
  }
}